var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffirmLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 24,
    rx: 2,
    fill: "#FBFAF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3153_19804)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77667 11.3252C8.8619 11.3252 7.80143 11.7456 7.22667 12.1815L7.75286 13.2402C8.21429 12.8354 8.95905 12.4929 9.63095 12.4929C10.2705 12.4929 10.6186 12.6953 10.6186 13.1078C10.6186 13.3881 10.3838 13.5282 9.94667 13.5827C8.29524 13.7851 7 14.221 7 15.4432C7 16.4084 7.72048 17 8.83762 17C9.63905 17 10.3514 16.5719 10.6914 16.0114V16.8444H12.181V13.3491C12.181 11.909 11.1367 11.3252 9.77667 11.3252ZM9.2181 15.8791C8.79714 15.8791 8.58667 15.6845 8.58667 15.3575C8.58667 14.7503 9.29095 14.548 10.5781 14.4156C10.5862 15.2252 10.0114 15.8791 9.2181 15.8791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2278 12.3839V11.4809H24.7383V16.8444H26.333V14.2599C26.333 13.03 27.1021 12.6719 27.6445 12.6719C27.8549 12.6719 28.1383 12.7342 28.3245 12.8665L28.6159 11.4497C28.373 11.3485 28.114 11.3252 27.9035 11.3252C27.0859 11.3252 26.5678 11.6755 26.2278 12.3839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0137 11.3252C35.1718 11.3252 34.5404 11.8078 34.2085 12.2671C33.9009 11.6677 33.2613 11.3252 32.4842 11.3252C31.6423 11.3252 31.0594 11.7767 30.7842 12.2905V11.4809H29.2461V16.8444H30.8409V14.0809C30.8409 13.0923 31.3832 12.6174 31.8851 12.6174C32.3385 12.6174 32.7594 12.8977 32.7594 13.6294V16.8444H34.3623V14.0809C34.3623 13.0767 34.8885 12.6174 35.4147 12.6174C35.8356 12.6174 36.2809 12.9132 36.2809 13.6216V16.8444H37.8756V13.139C37.8756 11.9324 37.0337 11.3252 36.0137 11.3252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.817 11.0839V11.4809H15.3965V10.936C15.3965 10.2276 15.8175 10.0252 16.1818 10.0252C16.3922 10.0252 16.6675 10.0719 16.8941 10.1965L17.388 9.11444C17.0965 8.95096 16.6189 8.80306 15.9794 8.80306C14.9594 8.80306 13.8018 9.35575 13.8018 11.0917V11.4887H12.8789V12.6719H13.8018V16.8444H15.3965V12.6641H17.817V16.8444H19.4118V12.6641H20.8608V11.4809H19.4118V10.936C19.4118 10.2276 19.8327 10.0252 20.197 10.0252C20.6018 10.0252 20.9094 10.1965 20.9094 10.1965L21.4032 9.11444C21.4032 9.11444 20.9013 8.80306 19.9946 8.80306C18.9827 8.79527 17.817 9.34797 17.817 11.0839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8047 11.481H23.3995V16.8444H21.8047V11.481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0997 4C26.793 4 22.9559 6.87246 21.8711 10.5701H23.4335C24.3401 7.81437 27.4244 5.4012 31.0997 5.4012C35.5682 5.4012 39.4216 8.67066 39.4216 13.7617C39.4216 14.906 39.2678 15.9335 38.9763 16.8443H40.4901L40.5063 16.7976C40.7573 15.8557 40.8787 14.8359 40.8787 13.7617C40.8787 8.08683 36.5801 4 31.0997 4Z",
    fill: "#4A4AF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3153_19804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 13,
    fill: "white",
    transform: "translate(7 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirmLight);
export default __webpack_public_path__ + "static/media/affirm-light.ec9658ef32f3c222ee6ccc6b80b1f4ea.svg";
export { ForwardRef as ReactComponent };